import { SITE_URL } from "@/constants/info"

export { SITE_URL, SCHEMA_IDS, SITE_NAME, SITE_FULL_NAME, SITE_DESCRIPTION, BRAND_NAME } from "@/constants/info"

export const toAbsoluteUrl = (path: string): string => {
  if (!path) return SITE_URL
  if (/^https?:\/\//i.test(path)) return path
  return `${SITE_URL}${path.startsWith('/') ? path : '/' + path}`
}
